/*
  The AppWorkspace provides the landing page for the selected application workspace.
  This compoenent is typically overwritten or extended by the application.
*/
import AppWorkspace from '@/agilis/components/AppWorkspace/AppWorkspace'

export default {
  name: 'AppWorkspaceMobile',
  mixins: [AppWorkspace]
}
